import Api from "..";
import { TransmedDistributionConfirmInput } from "../../dtos/transmed/process/process/distribution";
import { TransmedReceivingDetailWithProblems } from "../../dtos/transmed/process/receivingDetail";
import transform from "../../service/transform";

export default class TransmedDistributionApi extends Api {
  constructor() {
    super("transmed/registration/distribution");
  }

  public async get(
    lcId?: string
  ): Promise<TransmedReceivingDetailWithProblems[]> {
    const data = (await super.get(lcId)).data;
    if (!Array.isArray(data))
      throw new TypeError("TransmedReceiving entry list is not an array.");

    return await Promise.all(
      data.map(
        async (value) =>
          await transform(TransmedReceivingDetailWithProblems)(value)
      )
    );
  }

  public async post(): Promise<void> {
    await super.post();
  }

  public async put(
    registrationId: string,
    data: TransmedDistributionConfirmInput
  ): Promise<void> {
    await super.put(registrationId, data);
  }

  public async delete(registrationId: string): Promise<void> {
    await super.delete(registrationId);
  }
}
